import styled from "@emotion/styled"

const StyledContainer = styled.div<{
  paddingMobile?: boolean
  heightFull?: boolean
  noPadding?: boolean
}>`
  display: flex;
  flex-direction: column;
  z-index: 5;
  width: 100% !important;
  height: ${(p) => p.heightFull && "100%"};
  padding: ${(p) => p.paddingMobile && "0 20px"};
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 1280px;
    padding: 0 120px;
    margin: auto;
    ${(p) => p.noPadding && "padding: 0"};
  }
  ${({ theme }) => theme.breakpoints.up("xl")} {
    max-width: 1920px;
    padding: 0 240px;
    ${(p) => p.noPadding && "padding: 0"};
    margin: auto;
  }
`

type Props = {
  children: React.ReactNode
  paddingMobile?: boolean
  heightFull?: boolean
  noPadding?: boolean
  style?: React.CSSProperties
}

export default function Container({
  children,
  paddingMobile,
  heightFull,
  noPadding,
  style,
}: Props) {
  return (
    <StyledContainer
      paddingMobile={paddingMobile}
      heightFull={heightFull}
      style={style}
      noPadding={noPadding}
    >
      {children}
    </StyledContainer>
  )
}
